import axios from '../config/axios';

export function apiGetContext() {
  return axios.get('context');
};
